import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import ConnectPagePreview from '@/components/v2/preview/ConnectPagePreview.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
import FacebookPagesFetch from '@/components/facebook/FacebookPagesFetch.vue';
import PageTransition from '@/components/page_transition/Index.vue';
import BasePage from '@/components/v2/facebook/BasePage';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import PageSubscribe from '@/plugins/graphql/mutations/page-subscribe.gql';
import PageUnsubscribe from '@/plugins/graphql/mutations/page-unsubscribe.gql';
import DiyStepIndicator from '@/components/v2/DiyStepIndicator';
import DiyRouterLeaveGuard from '@/helpers/vue_mixins/v2/DiyRouterLeaveGuard';
import TheLeaveConfirmationDialog from '@/components/v2/diy/TheLeaveConfirmationDialog';
import { Mutation, Getter } from 'vuex-class';
import ActionButton from '@/components/action_button/Index.vue';
import PageListPaginator from '@/components/facebook/PageListPaginator.vue';
import DiyPreviewDrawerMixin from '@/helpers/vue_mixins/v2/DiyPreviewDrawerMixin';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
import ActiveFacebookPage from '@/plugins/graphql/queries/active-facebook-page.gql';
import activeFbPageByApp from '@/plugins/graphql/queries/v2/active-fb-page-by-app.gql';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import Modal from '@/components/v3/Modal.vue';
let PageActivation = class PageActivation extends Mixins(Mixins(GraphqlErrorMixin, DiyRouterLeaveGuard, DiyPreviewDrawerMixin, SegmentAnalyticsMixin, RouterPathMixin), CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.pageUuid = '';
        this.isConnected = false;
        this.pageName = 'PageName';
        this.pagePhotoUrl = 'PageName';
    }
    async handlePageSelection(isAlreadyConnected, page, userActivePageId, refetchQueries) {
        if (userActivePageId === 'Not Connected') {
            await this.onPageSelection(page);
        }
        else if (userActivePageId === page.id) {
            await this.onPageDisconnect();
        }
        else {
            this.errorNotification('Please Disconnect from the current active page');
        }
        await this.$apollo.queries.activeFbPageByApp?.refetch();
        await this.$apollo.queries.activePage?.refetch();
        await refetchQueries();
        if (this.isConnected === true) {
            this.goToMiniCustomization(this.pageUuid);
        }
    }
    get isAffiliateProp() {
        return this.isAffiliateMerchantDiy();
    }
    get stepProp() {
        return JSON.parse(this.step);
    }
    createFacebookPage() {
        window.open('https://www.facebook.com/pages/creation/?ref_type=pages_browser', '_blank');
    }
    goToMiniCustomization(pageUuid) {
        this.allowNavigation();
        this.$router.push({
            name: 'customize-mini-app',
            params: {
                serviceBundleUuid: this.serviceBundleUuid,
                appUuid: this.appUuid,
                pageUuid,
            },
        });
    }
    async onPageSelection(page) {
        this.mutationRequestOnFlight();
        await this.subscribe(page)
            .then(({ data }) => {
            const pageUuid = data.pageSubscribe.page.uuid;
            this.pageUuid = pageUuid;
            this.allowNavigation();
            let diy = 2;
            if (this.isAffiliateProp) {
                diy = 1;
            }
            this.segmentTrack(`DIY Step ${diy} - Page Activation`, {
                page_name: data.pageSubscribe.page.name,
            });
            this.onDIYConnectFacebookPage(data.pageSubscribe.page.name);
            if (this.isAffiliateProp) {
                this.$router.push({
                    name: 'affiliate-product-setup',
                    params: {
                        appUUID: this.appUuid,
                        step: '2',
                        isAffiliate: 'true',
                        diy: 'true',
                    },
                });
            }
            this.isConnected = true;
            this.successNotification('You have successfully subscribed to the page');
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async subscribe(page) {
        return this.$apollo.mutate({
            mutation: PageSubscribe,
            variables: {
                input: {
                    appUuid: this.appUuid,
                    accessToken: page.access_token,
                    fbPageId: page.id,
                    pageName: page.name,
                    photoUrl: page.picture.data.url,
                    diy: true,
                },
            },
        });
    }
    async onPageDisconnect() {
        this.mutationRequestOnFlight();
        await this.unsubscribe()
            .then(() => {
            this.isConnected = false;
            this.successNotification('You have successfully unsubscribed from the page');
            this.clearPersistentErrorNotification();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async unsubscribe() {
        return this.$apollo.mutate({
            mutation: PageUnsubscribe,
            variables: {
                input: {
                    appUuid: this.appUuid,
                },
            },
        });
    }
    mounted() {
        this.viewDIYPage('Connect Your Facebook Page');
    }
};
__decorate([
    Getter('requestOnFlight')
], PageActivation.prototype, "requestOnFlight", void 0);
__decorate([
    Mutation('requestOnFlight')
], PageActivation.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], PageActivation.prototype, "requestDone", void 0);
__decorate([
    Prop({ type: String, required: true })
], PageActivation.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: String, required: true })
], PageActivation.prototype, "serviceBundleUuid", void 0);
__decorate([
    Prop({ type: String, default: '2' })
], PageActivation.prototype, "step", void 0);
__decorate([
    Prop({ type: String, default: 'false' })
], PageActivation.prototype, "isAffiliate", void 0);
PageActivation = __decorate([
    Component({
        components: {
            BasePage,
            BaseOverlayLoader,
            ConnectPagePreview,
            DiyStepIndicator,
            FacebookPagesFetch,
            PageTransition,
            PageTitle,
            TheLeaveConfirmationDialog,
            ActionButton,
            PageListPaginator,
            Modal,
        },
        apollo: {
            activeFbPageByApp: {
                query: activeFbPageByApp,
                variables() {
                    return {
                        appUuid: this.$route.params.appUuid,
                    };
                },
                result(data) {
                    if (data.data.activeFbPageByApp === 'Not Connected') {
                        this.isConnected = false;
                    }
                    else {
                        this.isConnected = true;
                    }
                },
                skip() {
                    return !this.$route.params.appUuid;
                },
                fetchPolicy: 'no-cache',
            },
            activePage: {
                query: ActiveFacebookPage,
                variables() {
                    return {
                        appUUID: this.$route.params.appUuid,
                    };
                },
                result(data) {
                    this.pageName = data?.data?.activePage?.name;
                    this.pagePhotoUrl = data?.data?.activePage?.photoUrl;
                    return data?.data?.activePage;
                },
            },
        },
    })
], PageActivation);
export default PageActivation;
